import React from 'react';
import clsx from 'clsx';
import styles from './ActionRow.module.scss';

const ActionRow = ({
  children,
  density = 'auto',
  align = 'end',
  wrap = false
}) => {
  const className = clsx(
    styles.ActionRow
  );

  const DENSITY_OPTIONS = [
    'sm','md','lg','xl','xxl','xxxl','auto'
  ];
  const resolvedDensity = DENSITY_OPTIONS.includes(density) ? density : 'auto';

  return (
    <div
      className={className}
      data-density={resolvedDensity}
      data-align={align}
      data-wrap={wrap ? 'true' : 'false'}
    >
      {children}
    </div>
  );
};

export default ActionRow;
